var exports = {
  "HR": "NavBack__abKVIT",
  "mc": "Container__10sstY",
  "N_": "Link__UyJZJS",
};

module.exports = exports;
